/*
 * services.js
 *
 * Description: Holds 'Stores' Logic for Module:'Services'.
 *
 * This file is part of: "http://apps.sundair.com/", "Sundair-2019"
 * Copyright 2018,2019,2020 Sundair GmbH
 * Contact:  http://www.sundair.com/
 * @author Learek <michael.broeker@sundair.com>
 *
 */
import Vue from 'vue';
import axios from 'axios';
import { eventBus } from '../../../main';


//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$   /$$                /$$
// #   /$$__  $$ | $$               | $$
// #  | $$  \__//$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  |  $$$$$$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #   \____  $$ | $$     /$$$$$$$  | $$    | $$$$$$$$
// #   /$$  \ $$ | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  |  $$$$$$/ |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #   \______/   \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const state = {

    // >>> Are we in 'Services-Bookingno' Mode? -----------
    areWeInServicesBookingNoMode: false,

    // >>> 'BookingOptions Results' -----------------------
    servicesBookingOptionsResults: null,
    // >>> 'Bookable Services Results' --------------------
    servicesBookableServicesOutwardResults: null,
    servicesBookableServicesReturnResults: null,
    // >>> ------------------------------------------------
    servicesSrvcsMealExistsOnOut: false, // does Srvcs 'MEAL' exist on OUT?
    servicesSrvcsMealExistsOnRet: false, // does Srvcs 'MEAL' exist on OUT?
    servicesSrvcsServiceExistsOnOut: false, // and so on ...
    servicesSrvcsServiceExistsOnRet: false,
    servicesSrvcsPetsExistsOnOut: false,
    servicesSrvcsPetsExistsOnRet: false,
    servicesSrvcsSportbagExistsOnOut: false,
    servicesSrvcsSportbagExistsOnRet: false,
    servicesSrvcsBaggageExistsOnOut: false,
    servicesSrvcsBaggageExistsOnRet: false,
    servicesSrvcsMedicalExistsOnOut: false,
    servicesSrvcsMedicalExistsOnRet: false,

    // >>> ------------------------------------------------
    servicesValidatePassengersObject: null,                                     // Calls Object to send ..
    servicesValidatePassengersObjectClone: null,                               // Calls Object to send .. Clone
    servicesRegistrationValidateResponse: null,                                // Response of /registration/validate

    servicesProcessBookingObject: null, // Calls Object to send .. last call
    servicesProcessBookingResults: null,

    // >>> 'Bookingno' ------------------------------------
    flagServicesBookingnoLoginIsReadyForLogin: false, // 'Bookingno Login' ready?
    servicesUsersSearchDataBookingno: null,
    servicesBookingnoSearchResults: {}, // SearchResults (Bookingno)
    // >>> Flag: Show Section 'Bookingno Overview' --------
    flagServicesShowBookingnoSearchResults: false, // CONTROL FLAG - 'Search Results Section'





    // >>> Flag: Internal' --------------------------------
    bookableServicesCallOutDidRun: false, // CONTROL FLAG - Internal
    bookableServicesCallRetDidRun: false, // CONTROL FLAG - Internal
    gotSeatOnOut: false, // CONTROL FLAG - Internal
    gotSeatOnRet: false, // CONTROL FLAG - Internal
    seatplanCallCounter: 0 // Counts Seatplan Calls

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$              /$$     /$$
// #   /$$__  $$            | $$    | $$
// #  | $$  \__/  /$$$$$$  /$$$$$$ /$$$$$$    /$$$$$$   /$$$$$$  /$$$$$$$
// #  | $$ /$$$$ /$$__  $$|_  $$_/|_  $$_/   /$$__  $$ /$$__  $$/$$_____/
// #  | $$|_  $$| $$$$$$$$  | $$    | $$    | $$$$$$$$| $$  \__/  $$$$$$
// #  | $$  \ $$| $$_____/  | $$ /$$| $$ /$$| $$_____/| $$      \____  $$
// #  |  $$$$$$/|  $$$$$$$  |  $$$$/|  $$$$/|  $$$$$$$| $$      /$$$$$$$/
// #   \______/  \_______/   \___/   \___/   \_______/|__/     |_______/
// #
//-----------------------------------------------------------------------------/
const getters = {

    /***************************************************************************
    * Getters: 'Are we in 'Services Bookingno' Mode?
    ***************************************************************************/
    /***************************************************************************
    * get_areWeInServicesBookingNoMode()
    *
    * Desc: Are we in 'Services Bookingno' Mode?
    * Note:
    *
    */
    get_areWeInServicesBookingNoMode: state => {

        return state.areWeInServicesBookingNoMode;

    }, // eof get_areWeInServicesBookingNoMode()





    /***************************************************************************
    * Getters: FlightSearchResult, (Step 1)
    ***************************************************************************/
    /***************************************************************************
    * getServicesBookingOptions()
    *
    * Desc: Return Results of Call::'/registration/bookingoptions'.
    * Note:
    *
    */
    getServicesBookingOptions: state => {

        return state.servicesBookingOptionsResults;

    }, // eof getServicesBookingOptions()

    /***************************************************************************
    * getServicesDd2faRequired()
    *
    * Desc: Return DD 2FA requirement from booking options response.
    * Note: Source field is bookingOptions.required2FA.
    *
    */
    getServicesDd2faRequired: state => {

        return !!(state.servicesBookingOptionsResults &&
            state.servicesBookingOptionsResults.bookingOptions &&
            state.servicesBookingOptionsResults.bookingOptions.required2FA === true);

    }, // eof getServicesDd2faRequired()

    /***************************************************************************
    * getServicesRegistrationValidateResponse()
    *
    * Desc: Return Response of Call::'/registration/validate'.
    * Note: Contains bookingOptions.twoFaKeyCode for DD 2FA.
    *
    */
    getServicesRegistrationValidateResponse: state => {

        return state.servicesRegistrationValidateResponse;

    }, // eof getServicesRegistrationValidateResponse()

    /***************************************************************************
    * getServicesTwoFaKeyCode()
    *
    * Desc: Return twoFaKeyCode from registration validate response.
    * Note: One-time UUID token for /registration/2fa/send and newspecials.
    *
    */
    getServicesTwoFaKeyCode: state => {

        if (!state.servicesRegistrationValidateResponse ||
            !state.servicesRegistrationValidateResponse.bookingOptions) {
            return null;
        }

        return state.servicesRegistrationValidateResponse.bookingOptions.twoFaKeyCode || null;

    }, // eof getServicesTwoFaKeyCode()

    /***************************************************************************
    * getServicesBookableServicesOutward()
    *
    * Desc: Return Results of Call::'/registration/bookableservices'.
    * Note: 'Outward Flights' Services.

    */
    getServicesBookableServicesOutward: state => {

        return state.servicesBookableServicesOutwardResults;

    }, // eof getServicesBookableServicesOutward()

    /***************************************************************************
    * getServicesBookableServicesReturn()
    *
    * Desc: Return Results of Call::'/registration/bookableservices'.
    * Note: 'Return Flights' Services.

    */
    getServicesBookableServicesReturn: state => {

        return state.servicesBookableServicesReturnResults;

    }, // eof getServicesBookableServicesReturn()





    /***************************************************************************
    * Getters: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * getServicesDoesAnySrvcsExistAtAll()
    *
    * Desc: Return 'We have any srvcs on Flight?  With Seats included!'
    * Note:
    *
    */
    getServicesDoesAnySrvcsExistAtAll: state => {


        let srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;


        if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length === 0) {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.servicesBookableServicesReturnResults !== null) {
            if (state.servicesBookableServicesReturnResults.bookableServicesRS.services.length === 0) {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }


        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }


        return doesAnySrvcsExistAtAll;

    }, // eof getServicesDoesAnySrvcsExistAtAll()

    /***************************************************************************
    * getServicesDoesAnySrvcsExistAtAllWOSeats()
    *
    * Desc: Return 'We have any srvcs on Flight? Without Seats!'
    * Note:
    *
    */
    getServicesDoesAnySrvcsExistAtAllWOSeats: state => {


        let srvcsExistOnOut = false,
            srvcsExistOnRet = false,
            doesAnySrvcsExistAtAll = true;


        if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length === 0) {
            srvcsExistOnOut = false;
        } else if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length === 1 && state.servicesBookableServicesOutwardResults.bookableServicesRS.services[0].code === 'SEAT') {
            srvcsExistOnOut = false;
        } else {
            srvcsExistOnOut = true;
        }

        if (state.servicesBookableServicesReturnResults !== null) {
            if (state.servicesBookableServicesReturnResults.bookableServicesRS.services.length === 0) {
                srvcsExistOnRet = false;
            } else if (state.servicesBookableServicesReturnResults.bookableServicesRS.services.length === 1 && state.servicesBookableServicesReturnResults.bookableServicesRS.services[0].code === 'SEAT') {
                srvcsExistOnRet = false;
            } else {
                srvcsExistOnRet = true;
            }
        }



        if (srvcsExistOnOut === false && srvcsExistOnRet === false) {
            doesAnySrvcsExistAtAll = false;
        }


        return doesAnySrvcsExistAtAll;

    }, // eof getServicesDoesAnySrvcsExistAtAllWOSeats()



    /***************************************************************************
    * getServicesSrvcsMealExists()
    *
    * Desc: Return if Srvcs 'MEAL' exists?
    * Note:
    *
    */
    getServicesSrvcsMealExists: state => {

        if (state.servicesSrvcsMealExistsOnOut === true || state.servicesSrvcsMealExistsOnRet === true) {
            return true;
        } else {
            return false;
        }

    }, // eof getServicesSrvcsMealExists()

    /***************************************************************************
    * getServicesSrvcsServiceExists()
    *
    * Desc: Return if Srvcs 'SERVICE' exists?
    * Note:
    *
    */
    getServicesSrvcsServiceExists: state => {

        if (state.servicesSrvcsServiceExistsOnOut === true || state.servicesSrvcsServiceExistsOnRet === true) {
            return true;
        } else {
            return false;
        }

    }, // eof getServicesSrvcsServiceExists()

    /***************************************************************************
    * getServicesSrvcsServiceExists()
    *
    * Desc: Return if Srvcs 'PETS' exists?
    * Note:
    *
    */
    getServicesSrvcsPetsExists: state => {

        if (state.servicesSrvcsPetsExistsOnOut === true || state.servicesSrvcsPetsExistsOnRet === true) {
            return true;
        } else {
            return false;
        }

    }, // eof getServicesSrvcsPetsExists()

    /***************************************************************************
    * getServicesSrvcsSportbagExists()
    *
    * Desc: Return if Srvcs 'SPORTBAG' exists?
    * Note:
    *
    */
    getServicesSrvcsSportbagExists: state => {

        if (state.servicesSrvcsSportbagExistsOnOut === true || state.servicesSrvcsSportbagExistsOnRet === true) {
            return true;
        } else {
            return false;
        }

    }, // eof getServicesSrvcsSportbagExists()

    /***************************************************************************
    * getServicesSrvcsBaggageExists()
    *
    * Desc: Return if Srvcs 'BAGGAGE' exists?
    * Note:
    *
    */
    getServicesSrvcsBaggageExists: state => {

        if (state.servicesSrvcsBaggageExistsOnOut === true || state.servicesSrvcsBaggageExistsOnRet === true) {
            return true;
        } else {
            return false;
        }

    }, // eof getServicesSrvcsBaggageExists()

    /***************************************************************************
    * getServicesSrvcsMedicalExists()
    *
    * Desc: Return if Srvcs 'MEDICAL' exists?
    * Note:
    *
    */
    getServicesSrvcsMedicalExists: state => {

        if (state.servicesSrvcsMedicalExistsOnOut === true || state.servicesSrvcsMedicalExistsOnRet === true) {
            return true;
        } else {
            return false;
        }

    }, // eof getServicesSrvcsMedicalExists()


    /***************************************************************************
    * getServicesPassengersSrvcsOfType()
    *
    * Desc: Returns an Array of Srvcs of Type ...!
    * Note: Works for all Services Categories/Types.
    *
    */
    getServicesPassengersSrvcsOfType: state => payload => {

        let srvcsArray = [];


        for (var i = 0; i < state.servicesBookableServicesOutwardResults.bookableServicesRS.services.length; i++) {
            if (state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].categoryCode === payload.type) {
                srvcsArray.push({
                    id: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].id,
                    description: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].description,
                    remark: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].remark,
                    code: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].code,
                    price: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].price,
                    maxBookablePax: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].maxBookablePax,
                    acceptComment: state.servicesBookableServicesOutwardResults.bookableServicesRS.services[i].acceptComment,
                    srvc_exist_out: true,
                    srvc_exist_ret: false
                });
            }
        }

        if (state.servicesBookableServicesReturnResults !== null) {
            for (var i = 0; i < state.servicesBookableServicesReturnResults.bookableServicesRS.services.length; i++) {
                if (state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].categoryCode === payload.type) {
                    const result = srvcsArray.findIndex(srvcs => srvcs.id === state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].id);
                    if (result === -1) {  // We dont have this 'servicecat' yet -> simply 'insert' it.
                        srvcsArray.push({
                            id: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].id,
                            description: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].description,
                            remark: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].remark,
                            code: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].code,
                            price: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].price,
                            maxBookablePax: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].maxBookablePax,
                            acceptComment: state.servicesBookableServicesReturnResults.bookableServicesRS.services[i].acceptComment,
                            srvc_exist_out: false,
                            srvc_exist_ret: true
                        });
                    } else {  // We have this 'srvcs' already -> simply 'update' it.
                        srvcsArray[result].srvc_exist_ret = true;
                    }
                }
            }
        }


        return srvcsArray;

    }, // eof getServicesPassengersSrvcsOfType()





    /***************************************************************************
    * Getters: 'Payment', (Step 3)
    ***************************************************************************/
    /***************************************************************************
    * getServicesValidatePassengersObject()
    *
    * Desc: Return 'Object we sent in validatePassenger Call'.
    * Note:
    *
    */
    getServicesValidatePassengersObject: state => {

        return state.servicesValidatePassengersObject;

    }, // eof getServicesValidatePassengersObject()

    /***************************************************************************
    * getServicesValidatePassengersObjectClone()
    *
    * Desc: Return 'Object we sent in validatePassenger Call'. Clone.
    * Note:
    *
    */
    getServicesValidatePassengersObjectClone: state => {

        return state.servicesValidatePassengersObjectClone;

    }, // eof getServicesValidatePassengersObjectClone()




    /***************************************************************************
    * Getters: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * getServicesProcessBookingObject()
    *
    * Desc: Return 'Object we sent in processBooking Call'.
    * Note:
    *
    */
    getServicesProcessBookingObject: state => {

        return state.servicesProcessBookingObject;

    }, // eof getServicesProcessBookingObject()

    /***************************************************************************
    * getServicesProcessBookingResults()
    *
    * Desc: Return Results of ProcessBooking (Calls Response).
    * Note:
    *
    */
    getServicesProcessBookingResults: state => {

        return state.servicesProcessBookingResults;

    }, // eof getServicesProcessBookingResults()





    /***************************************************************************
    * Getters: 'Bookingno'
    ***************************************************************************/
    /***************************************************************************
    * getFlagServicesBookingnoLoginIsReadyForLogin()
    *
    * Desc: Return Flag: 'Bookingno is ready for Login?'
    * Note:
    *
    */
    getFlagServicesBookingnoLoginIsReadyForLogin: state => {

        return state.flagServicesBookingnoLoginIsReadyForLogin;

    }, // eo function getFlagServicesBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * get_ServicesUsersSearchDataBookingno()
    *
    * Desc: Returns Search Data (bookingCode lastName).
    * Note:
    *
    */
    get_ServicesUsersSearchDataBookingno: state => {

        return state.servicesUsersSearchDataBookingno;

    }, // eo function get_ServicesUsersSearchDataBookingno()


    /***************************************************************************
    * get_ServicesBookingnoSearchResults()
    *
    * Desc: Return Bookingno Search Results.
    * Note:
    *
    */
    get_ServicesBookingnoSearchResults: state => {

        return state.servicesBookingnoSearchResults;

    }, // eo function get_ServicesBookingnoSearchResults()


    /***************************************************************************
    * get_ServicesBookingnoSearchResultsPassengersSorted()
    *
    * Desc: Return Bookingno Search Results Passengers (sorted).
    * Note:
    * Note: Build 'own' id_pax.
    *
    */
    get_ServicesBookingnoSearchResultsPassengersSorted: state => {

        state.servicesBookingnoSearchResults[0].passengers.forEach((item, i) => {
            if (item.salutation === 'MR' || item.salutation === 'MRS') {
                item.order = 1;
            }
            if (item.salutation === 'CHD') {
                item.order = 2;
            }
            if (item.salutation === 'INF') {
                item.order = 3;
            }
        });


        state.servicesBookingnoSearchResults[0].passengers.sort(function (a, b) {
            return a.order - b.order;
        });


        state.servicesBookingnoSearchResults[0].passengers.forEach((item, i) => {
            item.id_pax_own = i + 1;
        });


        return state.servicesBookingnoSearchResults[0].passengers;

    }, // eo function get_ServicesBookingnoSearchResultsPassengersSorted()


    /***************************************************************************
    * get_ServicesBookingnoPassengersCountAll()
    *
    * Desc: Return Bookingno Search Results Passengers Count.
    * Note:
    *
    */
    get_ServicesBookingnoPassengersCountAll: state => {

        return state.servicesBookingnoSearchResults[0].passengers.length;

    }, // eo function get_ServicesBookingnoPassengersCountAll()


    /***************************************************************************
    * get_ServicesBookingnoPassengersCount()
    *
    * Desc: Return Bookingno Search Results Passengers Count.
    * Note: Getter with Payload!
    *
    */
    get_ServicesBookingnoPassengersCount: state => payload => {

        let paxCount = 0;


        if (payload  === 'ADT') {
            paxCount = state.servicesBookingnoSearchResults[0].passengers.filter(x => (x.salutation == 'MR' || x.salutation == 'MRS' )).length;
        }
        if (payload  === 'CHD') {
            paxCount = state.servicesBookingnoSearchResults[0].passengers.filter(x => x.salutation == 'CHD').length;
        }
        if (payload  === 'INF') {
            paxCount = state.servicesBookingnoSearchResults[0].passengers.filter(x => x.salutation == 'INF').length;
        }


        return paxCount;

    }, // eo function get_ServicesBookingnoPassengersCount()


    /***************************************************************************
    * get_ServicesBookingnoHasReturnFlight()
    *
    * Desc: Return .. Has Return Flight?
    * Note:
    *
    */
    get_ServicesBookingnoHasReturnFlight: state => {

        if (state.servicesBookingnoSearchResults[0].returnFlight !== undefined) {
            return true;
        } else {
            return false;
        }

    }, // eo function get_ServicesBookingnoHasReturnFlight()


    /***************************************************************************
    * get_ServicesBookingnoDepArprtNameOutuward()
    *
    * Desc: Return .. Apt Name, Departure, Outward
    * Note:
    *
    */
    get_ServicesBookingnoDepArprtNameOutuward: state => {

        return state.servicesBookingnoSearchResults[0].outwardFlight.departureAirportInfo.location;

    }, // eo function get_ServicesBookingnoDepArprtNameOutuward()

    /***************************************************************************
    * get_ServicesBookingnoDesArprtNameOutward()
    *
    * Desc: Return .. Apt Name, Destination, Outward
    * Note:
    *
    */
    get_ServicesBookingnoDesArprtNameOutward: state => {

        return state.servicesBookingnoSearchResults[0].outwardFlight.destinationAirportInfo.location;

    }, // eo function  get_ServicesBookingnoDesArprtNameOutward()

    /***************************************************************************
    * get_ServicesBookingnoDepArprtNameReturn()
    *
    * Desc: Return .. Apt Name, Departure, Return
    * Note:
    *
    */
    get_ServicesBookingnoDepArprtNameReturn: state => {

        return state.servicesBookingnoSearchResults[0].returnFlight.departureAirportInfo.location;

    }, // eo function get_ServicesBookingnoDepArprtNameReturn()

    /***************************************************************************
    * get_ServicesBookingnoDesArprtNameReturn()
    *
    * Desc: Return .. Apt Name, Destination, Return
    * Note:
    *
    */
    get_ServicesBookingnoDesArprtNameReturn: state => {

        return state.servicesBookingnoSearchResults[0].returnFlight.destinationAirportInfo.location;

    }, // eo function get_ServicesBookingnoDesArprtNameOutward()


    /***************************************************************************
    * get_ServicesBookingnoServicesPerPax()
    *
    * Desc: Return already booked Services of Pax.
    * Note: Getter with Payload!
    *
    */
    get_ServicesBookingnoServicesPerPax: state => payload => {

        let paxSrvcsList = [];


        state.servicesBookingnoSearchResults[0].passengers.forEach((pax, i) => {
            if (pax.id_pax_own === payload.id_pax) {
                if (payload.type === 'outward') {
                    paxSrvcsList = pax.outboundServices;
                }
                if (payload.type === 'return') {
                    paxSrvcsList = pax.inboundServices;
                }
            }
        });


        return paxSrvcsList;

    }, // eo function get_ServicesBookingnoServicesPerPax()




    /***************************************************************************
    * Getters: Control Flags (Bookingno)
    ***************************************************************************/
    /***************************************************************************
    * get_FlagServicesShowBookingnoSearchResults()
    *
    * Desc: Return Flag: 'Show Bookingno Overview Section'
    * Note:
    *
    */
    get_FlagServicesShowBookingnoSearchResults: state => {

        return state.flagServicesShowBookingnoSearchResults;

    }, // eo function get_FlagServicesShowBookingnoSearchResults()

};




//-----------------------------------------------------------------------------/
// #
// #   /$$      /$$             /$$                /$$
// #  | $$$    /$$$            | $$               | $$
// #  | $$$$  /$$$$ /$$   /$$ /$$$$$$   /$$$$$$  /$$$$$$    /$$$$$$
// #  | $$ $$/$$ $$| $$  | $$|_  $$_/  |____  $$|_  $$_/   /$$__  $$
// #  | $$  $$$| $$| $$  | $$  | $$     /$$$$$$$  | $$    | $$$$$$$$
// #  | $$\  $ | $$| $$  | $$  | $$ /$$/$$__  $$  | $$ /$$| $$_____/
// #  | $$ \/  | $$|  $$$$$$/  |  $$$$/  $$$$$$$  |  $$$$/|  $$$$$$$
// #  |__/     |__/ \______/    \___/  \_______/   \___/   \_______/
// #
//-----------------------------------------------------------------------------/
const mutations = {

    /***************************************************************************
    * Mutations: State Reset
    ***************************************************************************/
    /***************************************************************************
    * mut_set_stateResetServices()
    *
    * Desc: Reset State In Context:Services.
    * Note:
    * TODO: Reset more.
    *
    */
    mut_set_stateResetServices: (context, payload) => {

        state.servicesBookingOptionsResults = null;


        // >>> 'Bookable Services Results' --------------------
        state.servicesBookableServicesOutwardResults = null;
        state.servicesBookableServicesReturnResults = null;
        // >>> ------------------------------------------------
        state.servicesSrvcsMealExistsOnOut = false;
        state.servicesSrvcsMealExistsOnRet = false;
        state.servicesSrvcsServiceExistsOnOut = false;
        state.servicesSrvcsServiceExistsOnRet = false;
        state.servicesSrvcsPetsExistsOnOut = false;
        state.servicesSrvcsPetsExistsOnRet = false;
        state.servicesSrvcsSportbagExistsOnOut = false;
        state.servicesSrvcsSportbagExistsOnRet = false;
        state. servicesSrvcsBaggageExistsOnOut = false;
        state.servicesSrvcsBaggageExistsOnRet = false;
        state.servicesSrvcsMedicalExistsOnOut = false;
        state.servicesSrvcsMedicalExistsOnRet = false;
        // >>> ------------------------------------------------
        state.servicesValidatePassengersObject = null;
        state.servicesValidatePassengersObjectClone = null;
        state.servicesRegistrationValidateResponse = null;

        state.servicesProcessBookingObject = null;
        state.servicesProcessBookingResults = null;

        // >>> 'Bookingno' ------------------------------------
        // state.flagServicesBookingnoLoginIsReadyForLogin =  false;
        // state.servicesUsersSearchDataBookingno =  null;
        // state.servicesBookingnoSearchResults =  {};
        // >>> Flag: Show Section 'Bookingno Overview' --------
        // state.flagServicesShowBookingnoSearchResults =  false;

    }, // eof mut_set_stateResetServices()





    /***************************************************************************
    * Mutations: 'Are we in 'Services Bookingno' Mode?
    ***************************************************************************/
    /***************************************************************************
    * mut_set_areWeInServicesBookingNoMode()
    *
    * Desc: 'Are we in 'Services Bookingno' Mode?
    * Note:
    *
    */
    mut_set_areWeInServicesBookingNoMode: (context, payload) => {

        state.areWeInServicesBookingNoMode = payload;

    }, // eof mut_set_areWeInServicesBookingNoMode()





    /***************************************************************************
    * Mutations: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * mut_setServicesBookableServicesResults()
    *
    * Desc: SET State Call::'/registration/bookingoptions' Object/Results.
    * Note: Scan for different Services Categories/Types.
    * Note: I'm checking: 'meal', 'service', 'pets', 'sportbag', 'baggage', 'medical'.
    *
    */
    mut_setServicesBookableServicesResults: (state, payload) => {

        if (payload.type === 'outward') {

            // >>> Save calls response ----------
            state.servicesBookableServicesOutwardResults = payload.data;


            // >>> State of Srvcs ---------------
            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'meal') !== undefined) { // 'meal'
                state.servicesSrvcsMealExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'service') !== undefined) { // 'service'
                state.servicesSrvcsServiceExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'pets') !== undefined) { // 'pets'
                state.servicesSrvcsPetsExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'sportbag') !== undefined) { // 'sportbag'
                state.servicesSrvcsSportbagExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'baggage') !== undefined) { // 'baggage'
                state.servicesSrvcsBaggageExistsOnOut = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'medical') !== undefined) { // 'medical'
                state.servicesSrvcsMedicalExistsOnOut = true;
            }
        }


        if (payload.type === 'return') {
            state.servicesBookableServicesReturnResults = payload.data;

            // >>> State of Srvcs ---------------
            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'meal') !== undefined) { // 'meal'
                state.servicesSrvcsMealExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'service') !== undefined) { // 'service'
                state.servicesSrvcsServiceExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'pets') !== undefined) { // 'pets'
                state.servicesSrvcsPetsExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'sportbag') !== undefined) { // 'sportbag'
                state.servicesSrvcsSportbagExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'baggage') !== undefined) { // 'baggage'
                state.servicesSrvcsBaggageExistsOnRet = true;
            }

            if (payload.data.bookableServicesRS.services.find(srvcs => srvcs.categoryCode === 'medical') !== undefined) { // 'baggage'
                state.servicesSrvcsMedicalExistsOnRet = true;
            }
        }

    }, // eof mut_setServicesBookableServicesResults()




    /***************************************************************************
    * mut_setServicesValidatePassengersObject()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger).
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesValidatePassengersObject: (state, payload) => {

        state.servicesValidatePassengersObject = payload;

    }, // eof mut_setServicesValidatePassengersObject()

    /***************************************************************************
    * mut_setServicesValidatePassengersObjectClone()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger). Clone.
    * Note: Saves the Params itself.
    *
    */
   mut_setServicesValidatePassengersObjectClone: (state, payload) => {

        state.servicesValidatePassengersObjectClone = payload;

    }, // eof mut_setServicesValidatePassengersObjectClone()


    /***************************************************************************
    * mut_setServicesProcessBookingObject()
    *
    * Desc: SET State 'Calls Object to send' (validatePassenger).
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesProcessBookingObject: (state, payload) => {

        state.servicesProcessBookingObject = payload;

    }, // eof mut_setServicesProcessBookingObject()

    /***************************************************************************
    * mut_setServicesProcessBookingResults()
    *
    * Desc: SET State 'Calls Object RESPONSE' (process).
    * Note: Saves the Params itself.
    *
    */
    mut_setServicesProcessBookingResults: (state, payload) => {

        state.servicesProcessBookingResults = payload;

    }, // eof mut_setServicesProcessBookingResults()


    /***************************************************************************
    * mut_setServicesUpdateValidateObjectViaDeleteSrvcs()
    *
    * Desc:
    * Note:
    *
    */
    mut_setServicesUpdateValidateObjectViaDeleteSrvcs: (state, payload) => {

        let servicesValidatePassengersObject_Clone = { ...state.servicesValidatePassengersObject }; // copy


        // >>> A: 'bookingValidatePassengersObject' -------
        if (Object.keys(servicesValidatePassengersObject_Clone.length !== 0)) { // got Data (before validate!)?
            if (servicesValidatePassengersObject_Clone && servicesValidatePassengersObject_Clone.passengers) {
                for (var i = 0; i < servicesValidatePassengersObject_Clone.passengers.length; i++) {
                    if (parseFloat(servicesValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.payload.id_pax, 10)) {

                        for (var x = 0; x < servicesValidatePassengersObject_Clone.passengers[i].services.length; x++) {
                            if (servicesValidatePassengersObject_Clone.passengers[i].services[x].code === payload.payload.srvcs.code) {
                                if (payload.payload.type === 'outward') {
                                    if (servicesValidatePassengersObject_Clone.passengers[i].services[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedOutward) {
                                        servicesValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                    }
                                }

                                if (payload.payload.type === 'return') {
                                    if (servicesValidatePassengersObject_Clone.passengers[i].services[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedReturn) {
                                        servicesValidatePassengersObject_Clone.passengers[i].services.splice(x, 1);
                                    }
                                }

                            }
                        }
                    }
                }
            }
        }


        state.servicesValidatePassengersObject = servicesValidatePassengersObject_Clone;

    }, // eo function mut_setServicesUpdateValidateObjectViaDeleteSrvcs()


    /***************************************************************************
    * mut_setServicesUpdateValidateObjectViaDeleteSrvcs()
    *
    * Desc:
    * Note:
    *
    */
    mut_setServicesUpdateValidateObjectViaDeleteSeat: (state, payload) => {

        let servicesValidatePassengersObject_Clone = { ...state.servicesValidatePassengersObject }; // copy


        // >>> A: 'bookingValidatePassengersObject' -------
        if (Object.keys(servicesValidatePassengersObject_Clone).length !== 0) { // got Data (before validate!)?
            if (servicesValidatePassengersObject_Clone && servicesValidatePassengersObject_Clone.passengers) {
                for (var i = 0; i < servicesValidatePassengersObject_Clone.passengers.length; i++) {
                    if (parseFloat(servicesValidatePassengersObject_Clone.passengers[i].id_pax, 10) === parseFloat(payload.payload.id_pax, 10)) {
                        for (var x = 0; x < servicesValidatePassengersObject_Clone.passengers[i].seatServices.length; x++) {
                            if (payload.payload.type === 'outward') {
                                if (servicesValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedOutward) {
                                    servicesValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                                }
                            }

                            if (payload.payload.type === 'return') {
                                if (servicesValidatePassengersObject_Clone.passengers[i].seatServices[x].idFlight === payload.context.rootState.booking.bookingFlightIdSelectedReturn) {
                                    servicesValidatePassengersObject_Clone.passengers[i].seatServices.splice(x, 1);
                                }
                            }
                        }
                    }
                }
            }
        }


        state.servicesValidatePassengersObject = servicesValidatePassengersObject_Clone;

    }, // eo function mut_setServicesUpdateValidateObjectViaDeleteSeat()




    /***************************************************************************
    * Mutations: 'Bookingno'
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagServicesBookingnoLoginIsReadyForLogin()
    *
    * Desc: SET State 'Bookingno is ready for Login?' Boolean.
    * Note:
    *
    */
    mut_FlagServicesBookingnoLoginIsReadyForLogin: (state, payload) => {

        state.flagServicesBookingnoLoginIsReadyForLogin = payload;

    }, // eof mut_FlagServicesBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * mut_setServicesUsersSearchDataBookingno()
    *
    * Desc: ACTION 'SET Users Search Data Bookingno'.
    * Note:
    *
    */
    mut_setServicesUsersSearchDataBookingno: (state, payload) => {

        state.servicesUsersSearchDataBookingno = payload;

    }, // eof mut_setServicesUsersSearchDataBookingno()

    /***************************************************************************
    * mut_setServicesBookingnoSearchResults()
    *
    * Desc: ACTION 'SET Bookingno Search Results '.
    * Note: Ticket:#395, 'If we have only a Return ..'.
    *
    */
    mut_setServicesBookingnoSearchResults: (state, payload) => {


        if (payload[0].outwardFlight === undefined) {
            payload[0].outwardFlight = payload[0].returnFlight;                 // a) FlightObject twist
            delete payload[0].returnFlight;

            payload[0].passengers.forEach((item, i) => {                        // b) Services twist
                item.outboundServices = item.inboundServices;
                item.inboundServices = [];
            });
        }

        state.servicesBookingnoSearchResults = payload;

    }, // eof mut_setServicesBookingnoSearchResults()


    /***************************************************************************
    * Mutations: Control Flags
    ***************************************************************************/
    /***************************************************************************
    * mut_FlagServicesShowBookingnoSearchResults()
    *
    * Desc: SET State/Flag 'Show Bookinno Overview Section'
    * Note: CONTROL FLAG
    *
    */
    mut_FlagServicesShowBookingnoSearchResults: (state, payload) => {

        state.flagServicesShowBookingnoSearchResults = payload;

    }, // eof mut_FlagServicesShowBookingnoSearchResults()


    /***************************************************************************
    * mut_Flag_bookableServicesCallRetDidRun()
    *
    * Desc: SET State/Flag 'bookableServicesCallRetDidRun'
    * Note: CONTROL FLAG
    *
    */
    mut_Flag_bookableServicesCallRetDidRun: (state, payload) => {

        state.bookableServicesCallRetDidRun = payload;

    }, // eof mut_Flag_bookableServicesCallRetDidRun()










    /***************************************************************************
    * Mutations: 'Calls', (Shared: Services, Bookingno)
    ***************************************************************************/
    /***************************************************************************
    * mut_setServicesBookingOptionsResults()
    *
    * Desc:
    * Note:
    *
    */
    mut_setServicesBookingOptionsResults: (state, payload) => {

        state.servicesBookingOptionsResults = payload;

    }, // eo function mut_setServicesBookingOptionsResults()


    /***************************************************************************
    * mut_setServicesRegistrationValidateResponse()
    *
    * Desc: SET Response of /registration/validate.
    *
    */
    mut_setServicesRegistrationValidateResponse: (state, payload) => {

        state.servicesRegistrationValidateResponse = payload;

    }, // eof mut_setServicesRegistrationValidateResponse()

};




//-----------------------------------------------------------------------------/
// #
// #    /$$$$$$             /$$     /$$
// #   /$$__  $$           | $$    |__/
// #  | $$  \ $$  /$$$$$$$/$$$$$$   /$$  /$$$$$$  /$$$$$$$   /$$$$$$$
// #  | $$$$$$$$ /$$_____/_  $$_/  | $$ /$$__  $$| $$__  $$ /$$_____/
// #  | $$__  $$| $$       | $$    | $$| $$  \ $$| $$  \ $$|  $$$$$$
// #  | $$  | $$| $$       | $$ /$$| $$| $$  | $$| $$  | $$ \____  $$
// #  | $$  | $$|  $$$$$$$ |  $$$$/| $$|  $$$$$$/| $$  | $$ /$$$$$$$/
// #  |__/  |__/ \_______/  \___/  |__/ \______/ |__/  |__/|_______/
// #
//-----------------------------------------------------------------------------/
const actions = {

    /***************************************************************************
    * Actions: State Reset
    ***************************************************************************/
    /***************************************************************************
    * actn_set_stateReset()
    *
    * Desc: Reset States (In Services & Booking).
    * Note:
    * Note: [WATCHHOW] we reset in Context:Booking.
    *
    */
    actn_set_stateReset: (context, payload) => {

        context.commit('mut_set_stateResetBooking', payload, { root: true });   // reset in booking state context
        context.commit('mut_set_stateResetServices');                           // reset in services state context
        context.commit('mut_set_stateResetRebooking', payload, { root: true }); // reset in rebooking state context

    }, // eof actn_set_stateReset()





    /***************************************************************************
    * Actions: 'Are we in 'Services Bookingno' Mode?
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesBookableServicesResults()
    *
    * Desc: 'Are we in 'Services Bookingno' Mode?
    * Note:
    *
    */
    actn_set_areWeInServicesBookingNoMode: (context, payload) => {

        context.commit('mut_set_areWeInServicesBookingNoMode', payload);

    }, // eof actn_set_areWeInServicesBookingNoMode()






    /***************************************************************************
    * Actions: 'Passengers', (Step 2)
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesBookableServicesResults()
    *
    * Desc: ACTION 'SET Search Results'.
    * Note: Entire Response of Call::'/service/bookableservices'.
    *
    */
    actn_setServicesBookableServicesResults: (context, payload) => {

        context.commit('mut_setServicesBookableServicesResults', payload);

    }, // eof actn_setServicesBookableServicesResults()




    /***************************************************************************
    * actn_setServicesValidatePassengersObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger).
    * Note:
    *
    */
    actn_setServicesValidatePassengersObject: (context, payload) => {

        context.commit('mut_setServicesValidatePassengersObject', payload); // calling mutation

    }, // eof actn_setServicesValidatePassengersObject()


    /***************************************************************************
    * actn_setServicesValidatePassengersObjectClone()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger). Clone.
    * Note:
    *
    */
    actn_setServicesValidatePassengersObjectClone: (context, payload) => {

        context.commit('mut_setServicesValidatePassengersObjectClone', payload); // calling mutation

    }, // eof actn_setServicesValidatePassengersObjectClone()


    /***************************************************************************
    * actn_setServicesRegistrationValidateResponse()
    *
    * Desc: ACTION 'SET Response of /registration/validate'.
    *
    */
    actn_setServicesRegistrationValidateResponse: (context, payload) => {

        context.commit('mut_setServicesRegistrationValidateResponse', payload); // calling mutation

    }, // eof actn_setServicesRegistrationValidateResponse()


    /***************************************************************************
    * actn_setServicesUpdateValidateObjectViaDeleteSrvcs()
    *
    * Desc: ACTION 'SET Calls Object to send' (validatePassenger).
    * Note:
    *
    */
    actn_setServicesUpdateValidateObjectViaDeleteSrvcs: (context, payload) => {

        context.commit('mut_setServicesUpdateValidateObjectViaDeleteSrvcs', { payload: payload, context: context }); // calling mutation

    }, // eof actn_setServicesUpdateValidateObjectViaDeleteSrvcs()


    /***************************************************************************
    * actn_setServicesUpdateValidateObjectViaDeleteSeat()
    *
    * Desc:
    * Note:
    *
    */
    actn_setServicesUpdateValidateObjectViaDeleteSeat: (context, payload) => {

        context.commit('mut_setServicesUpdateValidateObjectViaDeleteSeat', { payload: payload, context: context }); // calling mutation

    }, // eof actn_setServicesUpdateValidateObjectViaDeleteSeat()




    /***************************************************************************
    * Actions: 'Overview', (Step 4)
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesProcessBookingObject()
    *
    * Desc: ACTION 'SET Calls Object to send' (process).
    * Note:
    *
    */
    actn_setServicesProcessBookingObject: (context, payload) => {

        context.commit('mut_setServicesProcessBookingObject', payload); // calling mutation

    }, // eof actn_setServicesProcessBookingObject()


    /***************************************************************************
    * Call::'/registration/newspecials2/'
    *
    * Desc: (Call) - Process Services ('registrationNewSpecials').
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_registrationNewSpecials: (context, payload) => {

        let hdrs = '',
            trsnltd = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/registration/newspecials2/', payload)
            .then(function (response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setServicesProcessBookingResults', response.data);
                        eventBus.$emit('readytoshowbookingsconfirmation'); // emit .. 'ready to push 'confirmation'
                        eventBus.$emit('readytoshowbookingsconfirmationoncheckout', response.data); // emit .. 'ready to push 'confirmation' (checkout)
                        break;
                    default: // 'ERROR'
                        trsnltd = Vue.prototype.$trnsl_error_message(response.headers["air41-error"]);
                        if (Vue.prototype.$isDd2faPinError(response.headers["air41-error"])) {
                            eventBus.$emit('dd2fa-process-pin-error', {
                                code: Vue.prototype.$extractAir41ErrorCode(response.headers["air41-error"]),
                                message: trsnltd,
                            });
                        }
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message: trsnltd
                        });
                        break;
                };
            })
            .catch(function (error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_registrationNewSpecials()




    /***************************************************************************
    * Actions: 'Bookingno'
    ***************************************************************************/
    /***************************************************************************
    * actn_setServicesUsersSearchDataBookingno()
    *
    * Desc: ACTION 'SET Users Search Data Bookingno'.
    * Note:
    *
    */
    actn_setServicesUsersSearchDataBookingno: (context, payload) => {

        context.commit('mut_setServicesUsersSearchDataBookingno', payload); // calling mutation

    }, // eo function actn_setServicesUsersSearchDataBookingno()


    /***************************************************************************
    * actn_setServicesBookingnoSearchResults()
    *
    * Desc: ACTION 'SET Search Bookingno Results'.
    * Note:
    *
    */
    actn_setServicesBookingnoSearchResults: (context, payload) => {

        context.commit('mut_setServicesBookingnoSearchResults', payload); // calling mutation

    }, // eo function actn_setServicesBookingnoSearchResults()



    /***************************************************************************
    * Actions: 'Bookingno', Control Flags
    ***************************************************************************/
    /***************************************************************************
    * actn_FlagServicesBookingnoLoginIsReadyForLogin()
    *
    * Desc: ACTION 'SET Flag: Bookingno is ready for Login'.
    * Note:
    *
    */
    actn_FlagServicesBookingnoLoginIsReadyForLogin: (context, payload) => {

        context.commit('mut_FlagServicesBookingnoLoginIsReadyForLogin', payload); // calling mutation

    }, // eo function actn_FlagServicesBookingnoLoginIsReadyForLogin()


    /***************************************************************************
    * actn_FlagServicesShowBookingnoSearchResults()
    *
    * Desc: ACTION 'Show Bookinno Overview Section'.
    * Note: CONTROL FLAG
    *
    */
    actn_FlagServicesShowBookingnoSearchResults: (context, payload) => {

        context.commit('mut_FlagServicesShowBookingnoSearchResults', payload); // calling mutation

    }, // eo function actn_FlagServicesShowBookingnoSearchResults()


    /***************************************************************************
    * actn_Flag_bookableServicesCallRetDidRun()
    *
    * Desc: ACTION 'SET Flag: '.
    * Note: CONTROL FLAG
    *
    */
    actn_Flag_bookableServicesCallRetDidRun: (context, payload) => {

        context.commit('mut_Flag_bookableServicesCallRetDidRun', payload); // calling mutation

    }, // eo function actn_Flag_bookableServicesCallRetDidRun()










    /***************************************************************************
    * Actions: 'Calls', (Shared: Services, Bookingno, Flights)
    ***************************************************************************/
    /***************************************************************************
    * Call::'/registration/overview/'
    *
    * Desc: (Call) - Getting original Booking Data via Bookingno.
    * Note:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_listOriginalBooking: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/registration/overview/', payload)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        eventBus.$emit('readytoshoworiginalbooking');           // emit .. 'ready to push 'passengers''
                        context.commit('mut_setServicesBookingnoSearchResults', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_listOriginalBooking()


    /***************************************************************************
    * Call::'/registration/bookingoptions/'
    *
    * Desc: (Call) - 'Get Bookingoptions'.
    * Note: Shared: 'Bookingno', 'Services'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_registrationBookingoptions: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        Vue.prototype.$vp_m();
        axios.put('/registration/bookingoptions/', payload)
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setServicesBookingOptionsResults', response.data);
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_registrationBookingoptions()


    /***************************************************************************
    * Call::'/service/bookableservices/{idFlight}/{tktClass}'
    *
    * Desc: (Call) - 'Get bookable Services'.
    * Note: Shared: 'Bookingno'
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: NEW: Using 'eventBus' to communicate.
    * Note: [WATCHHOW] Calling Actions from Actions.
    * Note: [WATCHHOW] Setting local State.
    *
    */
    actn_call_bookableServices: (context, payload) => {

        let hdrs = '',
            result = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/service/bookableservices/' + payload.id + '/Y', '')
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // >>> ---------------------------- save
                        context.commit('mut_setServicesBookableServicesResults', { data: response.data, type: payload.type });


                        // >>> ---------------------------- next 'out'
                        if (payload.type === 'outward') {
                            state.bookableServicesCallOutDidRun = true;         // Internal Flag
                            result = response.data.bookableServicesRS.services.findIndex(srvcs => srvcs.code === 'SEAT');

                            if (result !== -1) {                                // >>> Got Seats ...
                                state.gotSeatOnOut = true;                      // Internal Flag
                                context.commit("mut_setBookingSrvcsSeatExistOnOut", true, { root: true }); // set in booking state context
                                context.dispatch("actn_call_getSeatReservationLockingCode", { type: 'out', id: payload.id });
                            }
                        }

                        // >>> ---------------------------- next 'ret'
                        if (payload.type === 'return') {
                            state.bookableServicesCallRetDidRun = true;         // Internal Flag
                            result = response.data.bookableServicesRS.services.findIndex(srvcs => srvcs.code === 'SEAT');

                            if (result !== -1) {                                // >>> Got Seats ...
                                state.gotSeatOnRet = true;                      // Internal Flag
                                context.commit("mut_setBookingSrvcsSeatExistOnRet", true, { root: true }); // set in booking state context
                                context.dispatch("actn_call_getSeatReservationLockingCode", { type: 'ret', id: payload.id });
                            }
                        }


                        // >>> ---------------------------- all done?
                        if (state.gotSeatOnOut === false && state.gotSeatOnRet === false && state.bookableServicesCallOutDidRun === true && state.bookableServicesCallRetDidRun === true) {
                            Vue.prototype.$vp_um();

                            eventBus.$emit('readytopushpassengers');            // emit .. 'ready to push 'passengers''
                            eventBus.$emit('readytopushpassengersnotbookingno'); // emit .. 'ready to push 'passengers''

                            state.bookableServicesCallOutDidRun = false;        // reset
                            state.bookableServicesCallRetDidRun = false;
                        }
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_bookableServices()


    /***************************************************************************
    * Call::'/bookingapidev/seatplan/lock/67082/Y' (e.g.)
    *
    * Desc: (Call) - et Lockingcode for Service 'Seat'.
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    * Note: [WATCHHOW] Getting from global State.
    *
    */
    actn_call_getSeatReservationLockingCode: (context, payload) => {

        let hdrs = '',
            noSeats = 0,
            userSearchData = context.rootState.booking.bookingUsersSearchData;  // from booking state


        // >>> Send Ajax Request --------------------------
        noSeats = parseFloat(userSearchData.noADT, 10) + parseFloat(userSearchData.noCHD, 10) + parseFloat(userSearchData.noINF, 10);
        state.seatplanCallCounter += 1; // Internal Counter
        axios.get('/seatplan/lock/' + payload.id + '/Y/' + noSeats)
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                state.seatplanCallCounter -= 1; // Internal Counter
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setBookingSeatReservationLockingCodeResults', { response: response.data, type: payload.type }, { root: true }); // commit into booking state
                        context.dispatch("actn_call_getSeatPlan", { code: String(response.data.seatReservationLockingCode), type: payload.type }); // next
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getSeatReservationLockingCode()


    /***************************************************************************
    * Call::'/bookingapidev/seatplan/5792310ac5b9e90aae83d75cc1b5eb6c/'
    *
    * Desc: (Call) - Get Seatplan with Lockingcode.
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_getSeatPlan: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        state.seatplanCallCounter += 1; // Internal Counter
        axios.get('/seatplan/' + payload.code)
            .then(function(response) { // 'OK'
                hdrs = response.headers["air41-status"];
                state.seatplanCallCounter -= 1; // Internal Counter
                if (state.seatplanCallCounter === 1 || state.seatplanCallCounter === 0) {
                    Vue.prototype.$vp_um();
                }
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setBookingSeatplanResults', { response: response.data, type: payload.type }, { root: true }); // commit into booking state

                        if (state.seatplanCallCounter === 0) {
                            eventBus.$emit('readytopushpassengers');            // emit .. 'ready to push 'passengers''
                            eventBus.$emit('readytopushpassengersnotbookingno'); // emit .. 'ready to push 'passengers''

                            state.bookableServicesCallOutDidRun = false;        // reset
                            state.bookableServicesCallRetDidRun = false;
                            state.seatplanCallCounter = 0;
                        }
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_getSeatPlan()


    /***************************************************************************
    * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (PUT)
    *
    * Desc: (Call) - Lock Seat via Lockingcode + Seatno. (Attention: Method:PUT)
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_lockSeat: (context, payload) => {

        let hdrs = '';


        // >>> Send Ajax Request --------------------------
        axios.put('/seatplan/lock_code/' + payload.lockingcode + '/' + payload.seatno, null)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        context.commit('mut_setBookingUpdateCartWithSeat', payload, { root: true });   // set in booking state context
                        eventBus.$emit('readytoforcererender', { type: payload.type });                // emit .. 'ready to push 'passengers''
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });


    }, // eo function actn_call_getSeatPlan()


    /***************************************************************************
    * Call::'/seatplan/lock_code/' + lockingcode + '/' + seatno (DELETE)
    *
    * Desc: (Call) - UnLock Seat via Lockingcode + Seatno.
    * Note: Shared:
    * Note: [WATCHHOW] 'getting into Plugin' .. via Vue.prototype.
    *
    */
    actn_call_unlockSeat: (context, payload) => {

        let hdrs = ''


        // >>> Send Ajax Request --------------------------
        axios.delete('/seatplan/lock_code/' + payload.lockingcode + '/' + payload.seatno, null)
            .then(function(response) { // 'OK'
                Vue.prototype.$vp_um();
                hdrs = response.headers["air41-status"];
                switch (hdrs) {
                    case 'OK': // 'OK'
                        // Delete in Cart ...
                        context.commit('mut_setBookingUpdateCartViaDeleteSeat', { id_pax: payload.id_pax, type: payload.type }, { root: true }); // set in booking state context
                        // Lock ...
                        if (payload.lockAfterwards) {
                            eventBus.$emit('lockafterwards', payload.cellId);   // emit .. 'ready to push 'passengers''
                        }
                        break;
                    default: // 'ERROR'
                        Vue.prototype.$toasted.global.sdr_app_error({
                            message : response.headers["air41-error"]
                        });
                        break;
                };
            })
            .catch(function(error) { // 'ERROR'
                Vue.prototype.$vp_um();
                Vue.prototype.$toasted.global.sdr_app_error({
                    message: 'Service unavailable: ' + error
                });
            });

    }, // eo function actn_call_unlockSeat()

};




//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
//-----------------------------------------------------------------------------/
export default {
    state,
    getters,
    mutations,
    actions,
};
